import React, { useEffect, useRef, useState, SVGProps } from "react";
import { fetchPath } from "../../config/defPath";
import { LotteryBall } from "./LotteryBall";

import { LotteryState } from "../../config/types";

interface PorpsLottery {
    data: LotteryState["lottery"]
}


export const LotteryStatus: React.FC<PorpsLottery> = ({ data }) => {

    // const handleClick = async (e: any) => {
    //     e.preventDefault()

    //     window.dataLayer && window.dataLayer.push({
    //         "event": "GAEvent",
    //         "event_category": "Content",
    //         "event_action": "Button",
    //         "event_label": "Send Prediction",
    //         "interaction": "true",
    //         "component_name": "Modo_Carrera_Lottery",
    //         "element_text": "Enviar prediccion",
    //     });

    //     if (e.currentTarget.href) window.location.href = e.currentTarget.href
    // };

    return (
        <section className="lottery__content lottery__content--status blur-slow">
            <h1 className="lottery__content--title" dangerouslySetInnerHTML={{ __html: data.title2.value }}></h1>

            <div className="lottery__positions">
                <div className="lottery__content--subtitle" dangerouslySetInnerHTML={{ __html: data.subtitle2.value }}></div>
            </div>
            <div>
                <a className="lottery__content--btn" href={data.urlcerrada}>{data.btncerrada}</a>
            </div>
        </section>
    )
}
